import Image from 'next/image';
import { Article } from './types/Article';
import timeIcon from '../../../public/time_Icon.svg';
import dayjs from 'dayjs';

interface Props {
  articles: Article;
}

export const ArticlePost = ({ articles }: Props) => {
  const url = articles.link.replace('https://fukudake3ea3cd852.wpcomstaging.com', '');
  const formattedDate = dayjs(articles.modified).format('YYYY年MM月DD日');

  return (
    <li
      key={articles.id}
      className="table border-[#ccc] rounded-md ml-[10px] shadow-md  mb-2 w-auto h-[205px]"
    >
      <a href={'https://raysee.jp/column' + url} target="_blank">
        <div className="table-cell w-52 object-cover">
          <Image
            src={articles.jetpack_featured_media_url}
            alt="記事のサムネイル画像"
            width={200}
            height={150}
            className="w-full h-32 object-cover rounded-t-lg"
          />
          <div className=" w-52 text-sm whitespace-normal pt-[10px] pb-[15px] pl-[15px] pr-[15px]">
            <div className="flex mb-1">
              <Image src={timeIcon} width={12} height={12} alt={'時間'} />
              <p className="pl-1 text-xs">{formattedDate}</p>
            </div>
            <p className="text-xs font-bold text-ellipsis line-clamp-2">
              {articles.title.rendered}
            </p>
          </div>
        </div>
      </a>
    </li>
  );
};
